__webpack_require__.p = "/Rest-Countries-Api-Theme-Switcher/";